import { render } from "./StudyBox.vue?vue&type=template&id=1252ab1e"
import script from "./StudyBox.vue?vue&type=script&lang=js"
export * from "./StudyBox.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__